import { render, staticRenderFns } from "./rateInformation.vue?vue&type=template&id=0c25e49d&scoped=true"
import script from "./rateInformation.vue?vue&type=script&lang=js"
export * from "./rateInformation.vue?vue&type=script&lang=js"
import style0 from "./rateInformation.vue?vue&type=style&index=0&id=0c25e49d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25e49d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c25e49d')) {
      api.createRecord('0c25e49d', component.options)
    } else {
      api.reload('0c25e49d', component.options)
    }
    module.hot.accept("./rateInformation.vue?vue&type=template&id=0c25e49d&scoped=true", function () {
      api.rerender('0c25e49d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/components/rateInformation.vue"
export default component.exports